<script setup>
import ErrorSvg from '@images/status-fail-md.svg';
</script>

<template>
  <div class="text-center mt-5">
    <img
      :src="ErrorSvg"
      alt="Red x"
    >
    <h2 class="fw-bold mt-3">Something went wrong.</h2>
  </div>
  <div class="text-center">
    Please try again later.
    If the problem persists, please raise an issue in the
    <a
      href="https://gitlab.com/gitlab-org/developer-relations/contributor-success/contributors-gitlab-com/-/issues/new?issuable_template=default"
      target="_blank"
    >contributors-gitlab-com issue tracker</a>.
  </div>
</template>
